var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartGrayed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.507 19.8339L9.94896 18.4279C4.41596 13.3479 0.762965 10.0509 0.762965 5.94389C0.749405 5.16254 0.892722 4.3864 1.18443 3.66141C1.47615 2.93642 1.91033 2.27732 2.46128 1.72311C3.01223 1.16889 3.66876 0.730825 4.39201 0.434836C5.11526 0.138848 5.89054 -0.00905013 6.67197 -0.000105281C7.59432 0.00478265 8.50456 0.21036 9.33949 0.602353C10.1744 0.994346 10.914 1.56336 11.507 2.26989C12.0997 1.56344 12.8392 0.994463 13.6739 0.602471C14.5087 0.210478 15.4188 0.00486039 16.341 -0.000105281C17.1225 -0.00905344 17.8978 0.138876 18.6212 0.434926C19.3445 0.730977 20.001 1.16913 20.552 1.72345C21.103 2.27778 21.5371 2.937 21.8288 3.6621C22.1204 4.38721 22.2637 5.16345 22.25 5.94489C22.25 10.0519 18.597 13.3449 13.064 18.4289L11.507 19.8339Z",
    fill: "#D5D5D5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartGrayed);
export default __webpack_public_path__ + "static/media/heart_grayed.3005805b.svg";
export { ForwardRef as ReactComponent };